export type KhushiItineraryItem = {
  /** Stable key for per-item reveal config (Firestore). */
  id: string;
  /** When this item becomes visible for non-privileged viewers (ISO string). */
  revealAt?: string | null;
  /** Shown in both modes — keep vague before the reveal if you prefer */
  timeLabel: string;
  /** Full title — only for authenticated viewers on the allowlist */
  title: string;
  /** Optional subtitle / address hint */
  subtitle?: string;
  /** Body copy when revealed */
  notes?: string;
  /** Link to venue or maps — only used when revealed */
  linkUrl?: string;
  linkLabel?: string;
  /** Owner-only: confirmation / extranet links (not shown to Khushi) */
  reservationUrl?: string;
  /** Owner-only: booking refs, ops notes (not shown to Khushi) */
  ownerNotes?: string;
};
/**
 * Replace ownerNotes / reservationUrl with real values before the trip.
 * Guest-visible strings still ship in the bundle; owner fields are hidden in UI only.
 */
export const KHUSHI_ITINERARY: KhushiItineraryItem[] = [
  {
    id: "leave",
    timeLabel: "10:30 PM",
    title: "Leave Khushi's place",
    subtitle: "Long Island **** for privacy",
    notes:
      "Leave Khushi's parents house. Dress nice but comfy (we'll have time to change and do makeup more later). We'll stop for cake and fun juice on the way into the city.",
    linkUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
    linkLabel: "Top secret address to Khushi's house",
    reservationUrl: "https://example.com/placeholder-hotel-confirmation",
    ownerNotes:
      "PLACEHOLDER — paste hotel confirmation URL above. Ref: TBD. Early check-in request: TBD.",
  },
  {
    id: "hotel",
    timeLabel: "1:00 PM",
    title: "Dream Downtown",
    subtitle: "Chelsea, Manhattan",
    notes: "Check in, drop bags, freshen up. The adventure starts here.",
    linkUrl: "https://www.hyatt.com/dream-hotels/en-US/nycdd-dream-downtown",
    linkLabel: "Hotel",
    reservationUrl: "https://example.com/placeholder-hotel-confirmation",
    ownerNotes:
      "PLACEHOLDER — paste hotel confirmation URL above. Ref: TBD. Early check-in request: TBD.",
  },
  {
    id: "wildflower",
    timeLabel: "1:30 PM",
    title: "Wildflower",
    subtitle: "505 W 23rd St, Chelsea — optional lunch stop",
    notes:
      "Floral, aesthetic, high-rated spot right in the neighborhood. Good for a light bite after check-in if we're hungry.",
    linkUrl: "https://www.wildflowernyc.com",
    linkLabel: "Menu",
    reservationUrl: "https://example.com/placeholder-wildflower",
    ownerNotes:
      "PLACEHOLDER — walk-in or book ahead. Check veg options on menu.",
  },
  {
    id: "littleIsland",
    timeLabel: "2:30 PM",
    title: "Little Island",
    subtitle: "Pier 55, Hudson River Park",
    notes:
      "A floating park on the Hudson — free, stunning, and made for golden hour photos.",
    linkUrl: "https://littleisland.org",
    linkLabel: "Info",
    reservationUrl: "https://example.com/placeholder-little-island",
    ownerNotes:
      "PLACEHOLDER — no ticket usually; add any timed entry notes here.",
  },
  {
    id: "artechouse",
    timeLabel: "4:00 PM",
    title: "ARTECHOUSE",
    subtitle: "439 W 15th St, Chelsea",
    notes:
      "Immersive digital art experience right by the High Line. Tickets booked in advance.",
    linkUrl: "https://www.artechouse.com/location/nyc",
    linkLabel: "Tickets",
    reservationUrl: "https://example.com/placeholder-artechouse-tickets",
    ownerNotes:
      "PLACEHOLDER — ticket QR / order #. Confirm exhibit name before you go.",
  },
  {
    id: "veerays",
    timeLabel: "7:30 PM",
    title: "Veerays",
    subtitle: "213 E 45th St · Reservation under Ayushi",
    notes:
      "An Indian speakeasy — intimate, atmospheric, and exactly your kind of place. Happy birthday.",
    linkUrl: "https://veeraysnyc.com/menu",
    linkLabel: "Menu",
    reservationUrl: "https://example.com/placeholder-veerays-confirmation",
    ownerNotes:
      "PLACEHOLDER — OpenTable / Resy link & confirmation #. Party size + dietary flags.",
  },
  {
    id: "bar",
    timeLabel: "9:30 PM",
    title: "Dream Downtown Bar",
    subtitle: "Back at the hotel",
    notes:
      "Just us. Gifts, cocktails on the house, and getting ready to close out your birthday properly.",
    linkUrl: "https://www.dreamhotels.com/downtown-new-york/dining",
    linkLabel: "Bar Info",
    reservationUrl: "https://example.com/placeholder-bar-notes",
    ownerNotes:
      "PLACEHOLDER — room charge / guest list / anything staff should know.",
  },
  {
    id: "whisper",
    timeLabel: "11:00 PM",
    title: "Whisper Room",
    subtitle: "635 W 50th St · Bollywood Hip-Hop Night",
    notes: "Dance til 4am. You only turn 23 once.",
    linkUrl: "https://posh.vip/e/bollywood-x-hip-hop-night",
    linkLabel: "Venue",
    reservationUrl: "https://www.apple.com/wallet/",
    ownerNotes: "Link in apple wallet!!!",
  },
  {
    id: "getHome",
    timeLabel: "12:00 AM",
    title: "Get home",
    subtitle: "Hotel",
    notes: "Get home and sleep",
    reservationUrl: "https://example.com/placeholder-hotel-confirmation",
    ownerNotes:
      "PLACEHOLDER — paste hotel confirmation URL above. Ref: TBD. Early check-in request: TBD.",
  },
];
